<template>
  <div class="front-home">
    <div class="tool-bar">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="item in barImgList" :key="item.url">
          <img :src="item.url" :title="item.title" height="500px">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="aimcontent">
      <div style="display: flex; justify-content: center; margin-top: 40px">
        <div style="text-align: center; display: flex; flex-direction: row; width: 500px">
          <el-input
            placeholder="请输入内容"
            v-model="searchKeyWord"
            clearable>
          </el-input>
          <el-button type="primary" icon="el-icon-search">检索</el-button>
        </div>
      </div>
      <div style="margin-top: 30px">
        <img src="../../assets/images/left_img01.png">
        <img src="../../assets/images/left_word01.png">
      </div>
      <div style="margin: 0 auto;display: flex; justify-content: space-between; width: 1100px">
        <div v-for="item in tszyList"
             style="width: 200px; height: 150px; display: flex; flex-direction: column; border-radius: 5px; margin-top: 30px">
          <div
            style="display: flex; align-items: center; background-color: white; justify-content: space-around; padding: 5px" @click="toSecondPage(item.routerUrl)">
            <span style="cursor: default;">{{item.content}}</span>
            <img :src="item.url" :title="item.title" width="80px" height="80px" >
          </div>
          <div style="margin-top: 15px">
                <span style="color: #6a91ff; font-weight: bolder">
                  {{item.title}}
                </span>
          </div>
        </div>
      </div>

      <div style="margin-top: 30px">
        <img src="../../assets/images/left_img01.png">
        <img src="../../assets/images/left_word02.png">
      </div>
      <div style="margin: 0 auto;display: flex; justify-content: flex-start; width: 1100px; align-items: center;padding: 5px; margin-top: 5px">
        <div v-for="tj in tjList" style="width: 88px;;border-radius: 30px; padding: 5px;margin-left: 10px; cursor: pointer;"
             :style="{color:(tj.name === tjName)? '#00F' : 'black',border: (tj.name === tjName)? '1px solid #00F' : 'none'}"
             @click="changeTj(tj.name)"
             >
          {{tj.name}}
        </div>
      </div>
      <div
        style="margin: 0 auto;display: flex; justify-content: space-between; width: 1100px; align-items: center;padding: 5px">
        <div style="width: 60px; height: 100%; display: flex; align-items: center" class="left-but" @click="loadSubBookList(0)">
          <img src="../../assets/tstj/left-aim.png" width="60" height="134" class="b">
          <img src="../../assets/tstj/left-default.png" width="60" height="134" class="a">
        </div>

        <div style="height: 330px" :style="{display:tstjList.length === 0 ? 'block':'none'}">
        </div>
        <div v-for="item in tstjList"
             style="width: 230px; height: 300px; display: flex; flex-direction: column; border-radius: 5px; margin-top: 30px; " @click="getBookDetail(item.id)">
          <div style="display: flex; align-items: center; justify-content: space-around;">
            <img :src="item.url" :title="item.title" width="180px" height="270px">
          </div>
          <div style="margin-top: 15px">
                <span style="color: black; font-weight: bolder">
                  {{item.title}}
                </span>
          </div>
        </div>

        <div style="width: 60px; height: 100%; display: flex; align-items: center" class="right-but" @click="loadSubBookList(4)">
          <img src="../../assets/tstj/right-aim.png" width="60" height="134" class="d">
          <img src="../../assets/tstj/right-default.png" width="60" height="134" class="c">
        </div>
      </div>

      <div style="margin-top: 30px">
        <img src="../../assets/images/left_img01.png">
        <img src="../../assets/images/left_word03.png">
      </div>
      <div style="margin: 0 auto;display: flex; justify-content: space-between; width: 1100px; flex-wrap: wrap; ">
        <div v-for="item in sptjList"
             style="width: 230px; height: 160px; display: flex; flex-direction: column; border-radius: 5px; margin-top: 30px; background-color: #F5F8FF; padding: 15px">
          <div style="display: flex; align-items: center; justify-content: space-around;">
            <img :src="item.url" :title="item.title" width="222px" height="123px">
          </div>
          <div style="margin-top: 15px">
                <span style="color: black; font-weight: bolder">
                  {{item.title}}
                </span>
          </div>
        </div>
      </div>
      <div style=" display: flex; align-items: center;  width: 1100px; margin: 0 auto;margin-top: 30px">
        <img src="../../assets/images/down_icon01@2x.png" width="21px" height="21px">
        <span style="font-weight: bolder;margin-left: 10px ">{{aboutUsTitle}}</span>
      </div>
      <div class="pageWord">
        <div v-html="aboutUs">
        </div>
      </div>

      <div style=" display: flex; align-items: center;  width: 1100px; margin: 0 auto; margin-top: 30px">
        <img src="../../assets/images/down_icon01@2x.png" width="21px" height="21px">
        <span style="font-weight: bolder; margin-left: 10px">{{serviceItemTitle}}</span>
      </div>
      <div class="pageWord">
        <div v-html="serviceItem">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getSettingInfo,getBarList,getSpecialResourceList,qrySubEbookList,qrySubVideoList} from  '../../request/api';
  export default {
    name: 'front-home',
    data() {
      return {
        tjName: '首页推荐',
        tjList: [
          {
            id: 1,
            name: '首页推荐'
          },
          {
            id: 2,
            name: '佳作分享'
          },
          {
            id: 3,
            name: '综合推荐'
          },
        ],
        searchKeyWord: "",
        dialogFormVisible: false,
        formLabelWidth: '100px',
        barImgList: [
          /*{url: require("../../assets/toolbar/01bg.png"), title: "第一个图"},
          {url: require("../../assets/toolbar/02bg.png"), title: "第二个图"},
          {url: require("../../assets/toolbar/03bg.png"), title: "第三个图"},
          {url: require("../../assets/toolbar/04bg.png"), title: "第四个图"},*/
        ],
        tszyList: [
          /*{url: require("../../assets/tszy/book_img001.png"), title: "电子书库", content: "电子书设计各个学科，可在线阅读",routerUrl: "/front/dzslist"},
          {url: require("../../assets/tszy/img02.png"), title: "军事中文期刊库", content: "海量分类",routerUrl: "/front/splist"},
          {url: require("../../assets/tszy/img03.png"), title: "军事英文期刊库", content: "海量分类"},
          {url: require("../../assets/tszy/s-img04.png"), title: "视频库", content: "高清视频",routerUrl: "/front/splist"},
          {url: require("../../assets/tszy/img05.png"), title: "学位论文库", content: "论文文献", routerUrl: "/front/lwlist"},*/
        ],
        sptjList: [
          /*{url: require("../../assets/sptj/down_img01.png.png"), title: "电子书库", content: "电子书设计各个学科，可在线阅读"},
          {url: require("../../assets/sptj/down_img02.png.png"), title: "军事中文期刊库", content: "海量分类"},
          {url: require("../../assets/sptj/down_img03.png.png"), title: "军事英文期刊库", content: "海量分类"},
          {url: require("../../assets/sptj/down_img04.png.png"), title: "视频库", content: "高清视频"},
          {url: require("../../assets/sptj/down_img05.png.png"), title: "学位论文库", content: "论文文献"},
          {url: require("../../assets/sptj/down_img06.png.png"), title: "学位论文库", content: "论文文献"},
          {url: require("../../assets/sptj/down_img07.png.png"), title: "学位论文库", content: "论文文献"},
          {url: require("../../assets/sptj/down_img08.png.png"), title: "学位论文库", content: "论文文献"},*/
        ],
        tstjList: [
          /*{url: require("../../assets/tstj/first.png"), title: "婉约词", content: "电子书设计各个学科，可在线阅读"},
          {url: require("../../assets/tstj/second.png"), title: "婉约词", content: "海量分类"},
          {url: require("../../assets/tstj/third.png"), title: "婉约词", content: "海量分类"},
          {url: require("../../assets/tstj/forth.png"), title: "婉约词", content: "高清视频"},*/
        ],
        aboutUsTitle: "",
        aboutUs: "",
        serviceItemTitle:"",
        serviceItem: "",
        avatar: require("../../assets/avatar.png"),
        msg: 'Welcome to Your Vue.js App',
        telephone: "0078125400",
        position: "上海市杨浦区翔殷路800号",
        form: {
          userName: this.$route.params.userName,
          birth: this.$route.params.birth,
          sex: this.$route.params.sex,
          home: this.$route.params.home,
          aboutUs: this.$route.params.aboutUs
        },
      }
    },
    methods: {
      getBookDetail(id) {
        this.$router.push({name:"LwDetailPageIndex",query:{bookId:id}})
      },
      changeTj(tjName) {
        this.tjName = tjName;
        this.loadSubBookList();
      },
      loadSubBookList(nowPage) {
        let param = {
          nowPage: nowPage,
          tjName: this.tjName
        }
        qrySubEbookList(param).then(
          resp => {
            if (resp.code === 1) {
              this.tstjList = resp.data;
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      loadSubVideoList() {
        let param = {
        }
        qrySubVideoList(param).then(
          resp => {
            if (resp.code === 1) {
              this.sptjList = resp.data;
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },

      getRequire(url) {
        return require('../../' + url);
      },
      loadBarList() {
        let param = {
        }
        getBarList(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              resp.data.forEach((d) => {
                d.url = this.getRequire(d.url)
              })
              this.barImgList = resp.data
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      loadSpResList() {
        let param = {
        }
        getSpecialResourceList(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              resp.data.forEach((d) => {
                d.url = this.getRequire(d.url)
              })
              this.tszyList = resp.data
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      loadAboutInfo() {
        let param = {
          id: "aaa"
        }
        getSettingInfo(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              this.aboutUsTitle = resp.data.title;
              this.aboutUs = resp.data.content;
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      loadServiceItemInfo() {
        let param = {
          id: "bbb"
        }
        getSettingInfo(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              this.serviceItemTitle = resp.data.title;
              this.serviceItem = resp.data.content;
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      logout() {
        localStorage.removeItem("token");
        // 管理员页面
        this.$router.push('/');
      },
      handleEdit() {
        this.dialogFormVisible = true;
        //this.form.userName = this.$route.params.userInfo.userName;

      },
      toSecondPage(routerUrl) {
        console.log("定位地址:" + routerUrl)
        this.$router.push(routerUrl);
      }
    },
    mounted() {
      this.loadAboutInfo();
      this.loadServiceItemInfo();
      this.loadBarList();
      this.loadSpResList();
      this.loadSubBookList(0);
      this.loadSubVideoList();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .front-home {
    width: 100%;
    min-width: 1500px;
    max-width: 1920px;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .top {
    width: 100%;
    height: 42px;
    background-image: url("../../assets/images/top_bg.png");
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .dialogClass{
    min-width: 720px;
  }

  .footer {
    width: 100%;
    height: 199px;
    background-image: url("../../assets/images/down_porfile_bg.png");
  }

  .tool-bar {
    height: 500px;
  }

  .tool-bar .el-carousel__container {
    height: 500px
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .aimcontent {
    width: 100%;
    height: 1900px;
    background-image: url("../../assets/images/bg@2x.png");
  }

  .a {
    position: absolute;
  }

  .b {
    position: absolute;
  }

  .left-but:hover {
    .b {
      display: block
    }

    .a {
      display: none
    }
  }

  .c {
    position: absolute;
  }

  .d {
    position: absolute;
  }

  .right-but:hover {
    .d {
      display: block
    }

    .c {
      display: none
    }
  }

  .pageWord {
    margin: 0 auto;
    width: 1100px;
    margin-top: 20px;
    text-align: left;

  }

  .pageWord span {
    font-size: 18px;
    line-height: 25px;
    margin-left: 5px
  }
</style>



// WEBPACK FOOTER //
// src/components/front/home.vue